function install(Vue, options) {
	Vue.prototype.$trackPage = function(url, title) {
		this.$gtm.trackEvent({
			event: 'VirtualPageview',
			virtualPageURL: url,
			virtualPageTitle: title,
		})
	}

	Vue.prototype.$trackEvent = function(action, label) {
		this.$gtm.trackEvent({
			event: "standard",
			eventCategory: options.category,
			eventAction: action,
			eventLabel: label,
		})
	}
}

export default install